import './Checkbox-4e8297d1.css';

var classes = {"Checkbox":"prc-Checkbox-Checkbox-gIwWX","checkmarkOut":"prc-Checkbox-checkmarkOut-mlBVw","checkmarkIn":"prc-Checkbox-checkmarkIn-S5zG9"};

export { classes as default };
